


import React, { useContext, useEffect, useState } from "react";
import { patchData } from "../Service/ApiMethod";
import { LOCATION } from "../Service/service";
import Geocode from "react-geocode";
import Autocomplete from "react-google-autocomplete";
import { useRef } from "react";
import { t } from "i18next";
import { lang } from "../lang";
// import { UserContext } from "../App";



const UpdateLocation = (props) => {

  // const { user, setUser } = useContext(UserContext);
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [updatedLocation, setUpdatedLocation] = useState("");
  const [adress, setAdress] = useState(localStorage.getItem('address') || '');
  const [ln,setLn] = useState('en')
  const wrapperRef = useRef(null);

  useEffect(()=>{
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
  },[])


  console.log(updatedLocation);



  const setLocationPopup = props?.setLocationPopup
  useOutsideAlerter(wrapperRef);


  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setLocationPopup()

        }
      }

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }




  const updateLocation = () => {

    const obj = {
      latitude: localStorage.getItem('lat'),

      longitude: localStorage.getItem('lng'),
    };

    patchData(obj, LOCATION)
      .then((res) => res.json())
      .then((res) => {
        console.log(res, 'updated');
        try {
          alert(res.message);
          setLocationPopup()
          // setUser(!user)

        }
        catch (err) {
          alert(err)
        }
      });
  };

  useEffect(() => {

    Geocode.fromLatLng(localStorage.getItem('lat'), localStorage.getItem('lng')).then(
      (response) => {
        const address = response.results[0].formatted_address;
        let city, state, country;
        for (let i = 0; i < response.results[0].address_components.length; i++) {
          for (let j = 0; j < response.results[0].address_components[i].types.length; j++) {
            switch (response.results[0].address_components[i].types[j]) {
              case "locality":
                city = response.results[0].address_components[i].long_name;
                break;
              case "administrative_area_level_1":
                state = response.results[0].address_components[i].long_name;
                break;
              case "country":
                country = response.results[0].address_components[i].long_name;
                break;
            }
          }
        }
        console.log('adressssssssss', city, state, country);
        console.log(address);
        setAdress(address)
        localStorage.setItem('address', address)
      },
      (error) => {
        console.error(error);
      }
    );

  }, [])











  const handlePlaceSelect = (place) => {
    setUpdatedLocation(place.formatted_address);
    console.log(place?.geometry?.location);

  };
  console.log(updatedLocation, 'updatedLocation')


  Geocode.setApiKey("AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk");

  const currentLocation = () => {

    if (navigator?.geolocation) {
      navigator?.geolocation?.getCurrentPosition(function (position) {
        console.log("Latitude is :", position.coords.latitude);
        console.log("Longitude is :", position.coords.longitude);

        setLatitude(position?.coords?.latitude);
        setLongitude(position?.coords?.longitude);
        localStorage.setItem('lat', position.coords.latitude);
        localStorage.setItem('lng', position.coords.longitude);
        // setUser(true)

        setTimeout(() => {

          updateLocation();


        }, 1000)


      }, function (error) {
        console.log(error);
      });

    } else {
      console.log('error in locating')
    }

  };









  const GOOGLE_PLACES_API_KEY = 'AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk';

  const enteredLocation = () => {
    if (updatedLocation?.length != 0) {
      Geocode.fromAddress(updatedLocation).then(
        (response) => {
          const { lat, lng } = response?.results[0]?.geometry?.location;
          console.log(lat, lng, "lat lng ");
          setLatitude(lat);
          setLongitude(lng);
          localStorage.setItem('lat', lat)
          localStorage.setItem('lng', lng)
          // setUser(!user)

          setTimeout(() => {

            updateLocation();


          }, 1000)

        },

        (error) => {
          console.error(error);
        }
      );
    } else {
      alert('Please Enter the location')
    }

  };
  console.log(latitude, longitude, "fromenteredLocation");


  useEffect(() => {
    if (latitude && longitude) {
      // setUser(!user);
    }
  }, [latitude, longitude]);

  return (

    <div className="location-container" style={{ zIndex: "1" }} >

      <div className="form-container  relative" style={{}}  >
        <img style={{ background: 'red', width: '20px', height: '20px', borderRadius: '50%', position: 'absolute', right: '10px', marginTop: "-3px", cursor: 'pointer' }} src='../images/cross.png' alt='hello' onClick={() => {
          setLocationPopup()
        }

        } />

        <span>{lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Current Location']:""}: &nbsp;</span>
        {/* <button
              onClick={()=>{setLocationPopup()}}
              className="text btn-none view-all"
              style={{paddingLeft:"140px"}}
            >
              {t("Close")}
            </button> */}
        <h6 style={{ fontSize: '12px', marginBottom: '10px' }}>{adress}</h6>
        <Autocomplete

          // required="" }}
          value={updatedLocation}
          apiKey={GOOGLE_PLACES_API_KEY}
          onPlaceSelected={handlePlaceSelect}
          className="input-text w-100 popup-input"
          placeholder={t('Search by Area/Street/City Name')}
          onChange={(e) => {
            setUpdatedLocation(e.target.value);
          }}

        />
        <div className=" flex-center btn-flex-center">
          <button
            type="submit"
            class="theme-btn px-3 mx-1  text-center w-65"
            style={{ height: "30px", lineHeight: '16px', fontSize: '12px' }}
            onClick={() => {
              enteredLocation()

            }}
          >
            {lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile['Update Now']:""}
          </button>
          <button
            onClick={() => {

              currentLocation()

            }}
            type="submit"
            class="theme-btn mx-1  px-3  text-center w-65"
            style={{ height: "30px", lineHeight: '16px', fontSize: '12px' }}
          >
            {lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Current Location']:""}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateLocation;

